// Configuração global da versão da aplicação
export const APP_VERSION = "V1.0.0";
